import { Component, OnInit,OnChanges,SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { Observable } from 'rxjs';

import { AppSettings } from 'src/app/app.constant';
import { OrganisationService } from 'src/app/shared/services/organisation.service';
import { ExaminationService } from 'src/app/shared/services/examination.service';


@Component({
  selector: 'app-mark-list',
  templateUrl: './mark-list.component.html',
  styleUrls: ['./mark-list.component.css']
})

export class MarkListComponent implements OnInit {
  public resultdata:any;
  Exams:any;
  EnrollmentNo:string;
  message:any;
  msgData:any;
  htmldata:any;
  institutionlogo:any;
  organisationlogo:any;
  
  credit:any;
  TotalGradePoint:any;
  @ViewChild('content') content: ElementRef;
  
  constructor(  private _examinationservice:ExaminationService,
    private _organisationservice:OrganisationService,  ) { }

    ngOnInit() {

      this.getOrganisation();
  
      this._examinationservice.currentMessage
      .subscribe(
        message=>{
            this.msgData=message;
            var j=0;
            var tempval;
            this.htmldata="";
            var gradePoint=0;
            var gradePoint1=0;
            var gradePoint2=0;
            var credit=0;
            var GP=0;
            var totalGP=0;
            var totalGP1=0;
            var toralcredit=0;
            var totalgradePoint=0;
            var totalcredits=0;
            for ( var i=0;i < this.msgData.length;i++) {    
              tempval= this.msgData[i].ExamSection;
              this.institutionlogo='http://localhost:6064/Uploads/images/'+this.msgData[0].Logo;
              this.htmldata= this.htmldata+ `<tr><td colspan="4" class='tblcolumn'><b>Exam Session -  ${this.msgData[i].ExamSection}</b></td></tr>`;
                for (j;j< this.msgData.length;j++) {
                i=j;
                if(tempval==this.msgData[j].ExamSection) {
                    credit=this.msgData[j].Credit;
                    toralcredit=toralcredit+credit;
  
                    GP=this.msgData[j].GradePoint;
                    totalGP=credit*GP;
                    totalGP1=totalGP1+totalGP;
                    var hdata=`<tr><td>${this.msgData[j].SubjectCode}</td><td>${this.msgData[j].SubjectName}</td><td width="20%">${this.msgData[j].Grade}</td></tr>`;
                    this.htmldata= this.htmldata+hdata;
                    gradePoint2=gradePoint2+totalGP1;
                  }
                else  {
                    i=j-1;
                    tempval= this.msgData[j].ExamSection;
                    break;
                  }
                }
                totalcredits=totalcredits+toralcredit;
                  totalgradePoint=totalgradePoint+totalGP1;
                 // this.htmldata= this.htmldata+ `<tr><td colspan=4><b>GPA :  ${(gradePoint2/toralcredit).toFixed(2)}</b></td></tr>`;
                  //this.htmldata= this.htmldata+ `<tr><td>${totalgradePoint}</td><td>${totalcredits}</td><td>${toralcredit}</td><td>${totalGP1}</td><td colspan=4><b>GPA :  ${gradePoint2/toralcredit}</b></td></tr>`;
                  gradePoint2=0
                  toralcredit=0;
                  totalGP1=0;
              } 
              // this.htmldata= this.htmldata+ `<tr><td><b>CGPA : ${(totalcredits/totalgradePoint).toFixed(2)}</b></td></tr>`;
      });
    }
     
      
     
  getOrganisation() {
    this._organisationservice.getAllOrganisation(AppSettings.API_ENDPOINT+AppSettings.GetAllOrganisation)
      .subscribe(result =>{
          this.resultdata=result;
          this.organisationlogo='http://localhost:6064/Uploads/images/'+this.resultdata[0].Logo;
      if(!result){
          return;
    }
  });
  }
    


//   getBase64ImageFromURL(url: string) {
//     return Observable.create((observer: Observer<string>) => {
//       // create an image object
//       let img = new Image();
//       img.crossOrigin = 'Anonymous';
//       img.src = url;
//       if (!img.complete) {
//           // This will call another method that will create image from url
//           img.onload = () => {
//           observer.next(this.getBase64Image(img));
//           observer.complete();
//         };
//         img.onerror = (err) => {
//            observer.error(err);
//         };
//       } else {
//           observer.next(this.getBase64Image(img));
//           observer.complete();
//       }
//     });
//  }



  // ngOnChanges()
  // {
  //    this._examinationservice.currentMessage.subscribe(message=>this.message=message)
  //    console.log(this.message);

  //  this._examinationservice.getResultByEnrollmentNo(AppSettings.API_ENDPOINT+AppSettings.GetExamByEnrollmentNo,this.message)
  //    .subscribe(result =>{
  //   this.resultdata=result;
  //   console.table(this.resultdata);
  //   });
  // }

  
  public makePdf(enrollmentNo)  {  
    var data = document.getElementById('contentToConvert');  
    html2canvas(data).then(canvas => {  
      // Few necessary setting options  
      var imgWidth = 190;   
      var pageHeight = 295;    
      var imgHeight = canvas.height * imgWidth / canvas.width;  
      var heightLeft = imgHeight;  
       
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jsPDF('p', 'mm', 'a4'),
      margins = {
        top: 40,
        bottom: 60,
        left: 60,
        right:60,
        width: 522
      }; // A4 size page of PDF  
      var position = 15;  
      pdf.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight,)  
      pdf.save("ResultSlip"+enrollmentNo.trim()); // Generated PDF   
    });  
  }
}
